export default __webpack_public_path__ + "static/media/IMG_4551.75957239.jpeg";